import { useMemo } from 'react';
import type { User } from '../../../domain/entities';
import { UserRole } from '../../../domain/entities';
import type { MenuSettings } from '../types';

type FinancialSettingsSlice = Pick<MenuSettings, 'allowNonAdminRecipeAccess' | 'allowNonAdminCostAccess'> & {
  enableRecipeAndCosting?: boolean;
  allowManagersToViewCost?: boolean;
};

export interface FinancialVisibility {
  showCostData: boolean;
  canEditCost: boolean;
  showCostFields: boolean;
  canEditCostFields: boolean;
}

function resolveUserRole(userOrRole: User | UserRole | undefined | null): UserRole | undefined {
  if (!userOrRole) return undefined;
  return typeof userOrRole === 'string' ? userOrRole : userOrRole.role;
}

export function useFinancialVisibility(
  userOrRole: User | UserRole | undefined | null,
  settings: FinancialSettingsSlice | null | undefined,
): FinancialVisibility {
  return useMemo(() => {
    const userRole = resolveUserRole(userOrRole);
    const isEngineEnabled = settings?.enableRecipeAndCosting === true || settings?.allowNonAdminRecipeAccess === true;
    const isAdmin = userRole === UserRole.ADMIN || userRole === UserRole.SUPER_ADMIN;
    const managerAllowed = settings?.allowManagersToViewCost === true || settings?.allowNonAdminCostAccess === true;
    const isManager = userRole === UserRole.MANAGER;
    const showCostData = isEngineEnabled && (isAdmin || (isManager && managerAllowed));
    const canEditCost = isEngineEnabled && isAdmin;

    console.log('Visibility State:', { isEngineEnabled, managerAllowed, isAdmin, isManager, showCostData, canEditCost });

    return {
      showCostData,
      canEditCost,
      showCostFields: showCostData,
      canEditCostFields: canEditCost,
    };
  }, [settings?.allowManagersToViewCost, settings?.allowNonAdminCostAccess, settings?.allowNonAdminRecipeAccess, settings?.enableRecipeAndCosting, userOrRole]);
}